
import React from "react";
import { Helmet } from "react-helmet-async";

const AdminTransactions: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Transactions - Admin Dashboard</title>
      </Helmet>
      <div className="p-6">
        <h1 className="text-3xl font-bold mb-6">Transaction History</h1>
        <p className="text-muted-foreground">View and manage all transactions.</p>
      </div>
    </>
  );
};

export default AdminTransactions;
